import { Link } from "react-router-dom";
import { LOGO_URL, COMPANY } from "../lib/site";
import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
   <footer
  data-testid="site-footer"
  className="nav-dark relative bg-[color:var(--p10-ink)] text-white overflow-hidden"
>
      <div className="grain" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10 relative">
        {/* Big CTA */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-20 border-b border-white/10">
          <div className="md:col-span-8">
            <div className="eyebrow-dark mb-6">Get in touch</div>

            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] max-w-4xl">
              Let's connect your business
              <br />
              <span className="italic text-[color:var(--p10-warm)]">
                to the world.
              </span>
            </h2>

            <p className="mt-8 max-w-xl text-white/70 text-lg leading-relaxed">
              Whether you're expanding into new corridors, replacing fragmented
              integrations, or launching cross-border payments for the first
              time — Pay10x gives you one connection to get there.
            </p>
          </div>

          <div className="md:col-span-4 flex md:justify-end items-end">
            <div className="flex flex-col gap-3 w-full md:w-auto">
              <Link
                to="/contact"
                data-testid="footer-cta-contact"
                className="btn-square btn-electric"
              >
                Get in touch
                <ArrowUpRight className="ml-2 w-4 h-4" />
              </Link>

              <Link
                to="/contact"
                data-testid="footer-cta-demo"
                className="btn-square btn-ghost-dark"
              >
                Book a demo
              </Link>
            </div>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 py-16">
          <div className="col-span-2 md:col-span-4">
            <img
              src={LOGO_URL}
              alt="Pay10x"
              style={{ height: "80px", width: "auto" }}
              className="h-9 w-auto brightness-125 mb-6"
            />

            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              The integration layer for cross-border payments. Headquartered in
              Singapore, built for global scale.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow-dark mb-5">Product</div>

            <ul className="space-y-3 text-sm text-white/75">
              <li>
                <Link
                  to="/solutions"
                  data-testid="footer-link-solutions"
                  className="hover:text-white link-underline"
                >
                  Solutions
                </Link>
              </li>

              <li>
                <Link
                  to="/partnerships"
                  data-testid="footer-link-partnerships"
                  className="hover:text-white link-underline"
                >
                  Network Partnerships
                </Link>
              </li>

              <li>
                <Link
                  to="/developers"
                  data-testid="footer-link-developers"
                  className="hover:text-white link-underline"
                >
                  Developers
                </Link>
              </li>

              <li>
                <Link
                  to="/security"
                  data-testid="footer-link-security"
                  className="hover:text-white link-underline"
                >
                  Security &amp; Trust
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow-dark mb-5">Company</div>

            <ul className="space-y-3 text-sm text-white/75">
              <li>
                <Link
                  to="/about"
                  data-testid="footer-link-about"
                  className="hover:text-white link-underline"
                >
                  About
                </Link>
              </li>

              <li>
                <Link
                  to="/who-we-serve"
                  data-testid="footer-link-who"
                  className="hover:text-white link-underline"
                >
                  Who We Serve
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="hover:text-white link-underline"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-4">
            <div className="eyebrow-dark mb-5">Contact</div>

            <ul className="space-y-3 text-sm text-white/85">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 opacity-60" />
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="link-underline"
                >
                  {COMPANY.email}
                </a>
              </li>

              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 opacity-60" />
                <a
                  href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                  data-testid="footer-phone"
                  className="link-underline"
                >
                  {COMPANY.phone}
                </a>
              </li>

              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 opacity-60" />
                <span>{COMPANY.location}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-6 text-xs text-white/45">
          <div>
            © {new Date().getFullYear()} {COMPANY.company}. All rights reserved.
          </div>

          <div className="max-w-3xl leading-relaxed md:text-right">
            Pay10x is a payments technology and connectivity provider. Pay10x
            does not hold, safeguard, or take custody of client or transaction
            funds. Regulated payment services referenced on this site are
            provided by our licensed network partners.
          </div>
        </div>
      </div>
    </footer>
  );
}